import api from "@/api/apiConfig"
import {
  cacheTypes
} from '../common/dictionary'
import {
  Post,
  Get
} from './base/baseAjax'
let getDictionary = (param) => {
  return Get({
    url: api.common.getDictionary,
    cacheType: cacheTypes.formCache,
    PathParam: param
  })
}
let getDepart = (param) => {
  return Get({
    url: api.common.getDepart,
    bodyParam: param
  })
}
let getAllDepart = (param) => {
  return Get({
    url: api.common.getAllDepart,
    bodyParam: param
  })
}
let getPostByDepartId = (param) => {
  return Get({
    url: api.common.getPostByDepartId,
    UrlParam: param
  })
}
let getPersonByDepartId = (param) => {
  return Post({
    url: api.common.getPersonByDepartId,
    bodyParam: param
  })
}
let getPersonByPostId = (param) => {
  return Get({
    url: api.common.getPersonByPostId,
    PathParam: param
  })
}
let getBelonger = () => {
  return Get({
    url: api.common.getBelonger,
  })
}
let getCompany = () => {
  return Get({
    url: api.common.getCompany,
  })
}

let getCompanyByExpress = () => {
  return Get({
    url: api.common.getCompanyByExpress,
  })
}
let getUnder = (param) => {
  return Post({
    url: api.common.getUnder,
    bodyParam: param
  })
}
let getAll = (param) => {
  return Post({
    url: api.common.getAll,
    bodyParam: param
  })
}
let getProvince = (param) => {
  return Get({
    url: api.common.getProvince,
    bodyParam: param
  })
}
let getNumber = (param) => {
  return Get({
    url: api.common.getNumber,
    PathParam: param
  })
}
let ssoUpload = () => {
  return Get({
    url: api.common.ssoUpload,
  })
}
let getApprovalStatus = () => {
  return Get({
    url: api.common.getApprovalStatus,
  })
}
let getApp = () => {
  return Get({
    url: api.common.getApp,
  })
}
let getLevel = () => {
  return Get({
    url: api.common.getLevel,
  })
}
let getAllPermission = () => {
  return Get({
    url: api.common.getAllPermission
  })
}
let getunderlings = () => {
  return Get({
    url: api.common.getunderlings
  })
}
let getcompanydomains = () => {
  return Get({
    url: api.common.getcompanydomains
  })
}
let getApprovalType = () => {
  return Get({
    url: api.common.getApprovalType
  })
}

let getCourierCompany = () => {
  return Get({
    url: api.common.getCourierCompany
  })
}

let getCourierState = () => {
  return Get({
    url: api.common.getCourierState
  })
}

let getAppName = () => {
  return Get({
    url: api.common.getAppName
  })
}

let leavatype = () => {
  return Get({
    url: api.common.leavatype
  })
}

export default {
  getDepart,
  getAllDepart,
  getPostByDepartId,
  getPersonByDepartId,
  getDictionary,
  getPersonByPostId,
  getBelonger,
  getCompany,
  getUnder,
  getAll,
  getProvince,
  getNumber,
  ssoUpload,
  getApprovalStatus,
  getApp,
  getLevel,
  getAllPermission,
  getunderlings,
  getcompanydomains,
  getApprovalType,
  getCourierCompany,
  getCourierState,
  getAppName,
  getCompanyByExpress,
  leavatype
}



// WEBPACK FOOTER //
// ./src/services/common.js